module.exports = __webpack_public_path__ + "img/PL08454.cd5ef709.png";